import React from "react";
import "./PageContentFrame.css";

interface Props {
  children: React.ReactNode;
}

function PageContentFrame(props: Props) {
  const { children } = props;

  return <main className="page-content-frame">{children}</main>;
}

export default PageContentFrame;
